<template>
	<div class="flex flex-col items-center gap-12">
		<div class="flex flex-col items-center gap-4">
			<AtomTitle
				tag="h2"
				size="xl"
			>
				Kom samen in beweging
			</AtomTitle>
			<p class="text-functional-size-lg text-gray-700">
				Hier blijf je gemotiveerd.
			</p>
		</div>
		<div class="flex flex-col md:flex-row items-center justify-center gap-8">
			<AtomButton
				size="xl"
				text="Private Group Training informatie aanvragen"
				:variant="ButtonVariant.Green"
				icon-left="fa-envelope"
				:to="{ url: '#aanmelden', title: 'PGT informatie aanvragen' }"
				@click="trackButtonClick('Pgt1_CTA_Lead')"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';

const { trackButtonClick } = useEventTracking();
</script>
